import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import {
  addDownloadCaseReducers,
  addDownloadExtraReducers,
} from 'partner360/components/asyncContentWrapper/model'

import { initialState } from '../configs'

import * as downloadActions from './actions'
import { DOWNLOAD_TYPE_PREFIX } from './constants'
import { exportReportsPptxThunk } from './thunks'
import { generateAndPollReports } from './thunks/generateAndPollReports'
import { IMultiExportReportEntry, IReportProducts, IReportsState } from './types'

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    setProducts(state, action: PayloadAction<IReportProducts[]>) {
      state.products = action.payload
    },

    multiExportGeneratingFinished(state, action: PayloadAction<IMultiExportReportEntry[]>) {
      state.multiExport.isGenerating = false
      state.multiExport.generatedReportsIds = action.payload
    },

    multiExportStatusUpdated(state, action: PayloadAction<IMultiExportReportEntry[]>) {
      state.multiExport.generatedReportsIds = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(exportReportsPptxThunk.pending, (state) => {
        state.exportPptx.isLoading = true
      })
      .addCase(exportReportsPptxThunk.fulfilled, (state) => {
        state.exportPptx.isLoading = false
      })
      .addCase(exportReportsPptxThunk.rejected, (state) => {
        state.exportPptx.isLoading = false
      })
      .addCase(generateAndPollReports.pending, (state) => {
        state.multiExport.isGenerating = true
        state.multiExport.generatedReportsIds = []
      })
      .addCase(generateAndPollReports.fulfilled, (state) => {
        state.multiExport = initialState.multiExport
      })
      .addCase(generateAndPollReports.rejected, (state) => {
        state.multiExport = initialState.multiExport
      })

    addDownloadCaseReducers<IReportsState>(builder, downloadActions)
    addDownloadExtraReducers<IReportsState>(builder, DOWNLOAD_TYPE_PREFIX)
  },
})

export default reportsSlice.reducer

export const { setProducts, multiExportGeneratingFinished, multiExportStatusUpdated } =
  reportsSlice.actions

export * from './actions'
